import { StatusType, status } from '../typeStatus'

export const GET_PLAN_PUBLICACION_BY_PRODUCT_ID = 'GET_PLAN_PUBLICACION_BY_PRODUCT_ID'
export const GET_PLAN_PUBLICACION_BY_PRODUCT_ID_SUCCESS = 'GET_PLAN_PUBLICACION_BY_PRODUCT_ID_SUCCESS'
export const GET_PLAN_PUBLICACION_BY_PRODUCT_ID_ERROR = 'GET_PLAN_PUBLICACION_BY_PRODUCT_ID_ERROR'

export interface PlanPublicacionByProductIdDTO {
  productoId: number
  planId: number
}

export const InitialState: PlanPublicacionState = {
  status: status.initial,
  planByProductId: null,
}

export interface PlanPublicacionState {
  status: StatusType
  planByProductId: PlanPublicacionByProductIdDTO | null
}

export interface GetPlanPublicacionByProducId {
  type: typeof GET_PLAN_PUBLICACION_BY_PRODUCT_ID
  payload: null
}

export interface GetPlanPublicacionByProducIdSuccess {
  type: typeof GET_PLAN_PUBLICACION_BY_PRODUCT_ID_SUCCESS
  payload: PlanPublicacionByProductIdDTO
}
export interface GetPlanPublicacionByProducIdError {
  type: typeof GET_PLAN_PUBLICACION_BY_PRODUCT_ID_ERROR
  payload: null
}

export type PlanPublicacionActions =
  | GetPlanPublicacionByProducId
  | GetPlanPublicacionByProducIdSuccess
  | GetPlanPublicacionByProducIdError
